import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import type { EmployeeStatus } from '@ip/shared-types';

const STATUS_CLASSES: Record<EmployeeStatus, string> = {
  active: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400',
  expiring_soon: 'border-amber-500/40 bg-amber-500/10 text-amber-700 dark:text-amber-400',
  expired: 'border-red-500/40 bg-red-500/10 text-red-700 dark:text-red-400',
  terminated: 'border-border text-muted-foreground',
};

interface EmployeeStatusBadgeProps {
  status: EmployeeStatus;
}

export function EmployeeStatusBadge({ status }: EmployeeStatusBadgeProps) {
  return (
    <Badge variant="outline" className={cn('font-normal', STATUS_CLASSES[status])}>
      {t(`employees.status.${status}`)}
    </Badge>
  );
}
